<template>
	<v-alert prominent type="error" v-if="!value">
		<v-row align="center">
			<v-col class="grow">
				{{ $t("label.outlet_is_closed_notice") }}
			</v-col>
			<v-col class="shrink">
				<v-btn color="red" dark>
					{{ $t("label.browse_another") }}
				</v-btn>
			</v-col>
		</v-row>
	</v-alert>
</template>

<script>
export default {
	props: ["value"],
};
</script>